(function() {
  var settings = window.dwMemberPricing || {};
  var labels = settings.labels || {};
  var pricingMode = settings.mode === 'open_sale' ? 'open_sale' : 'members';
  var isMembersMode = pricingMode === 'members';
  var formattedAttribute = 'data-member-pricing-formatted';
  var cbbFormattedAttribute = 'data-member-pricing-cbb-formatted';
  var memberPricingSyncQueued = false;
  var memberPricingSyncScopes = [];
  var upcartMemberLabelClass = 'upcart-member-label';
  var upcartMemberSavingClass = 'upcart-member-saving';
  var ratingObservedAttribute = 'data-dw-rating-observed';
  var recommendationFallbackAttribute = 'data-dw-recommendation-fallback-requested';
  var recommendationTargetCount = 10;
  var cbbEnhanceTimer = null;
  var cbbTitleSyncTimer = null;
  var ratingCachePrefix = 'dw-product-rating-v3:';
  var ratingCacheLifetime = 30 * 60 * 1000;
  var ratingRequests = {};
  var ratingObserver = null;
  var recommendationObserver = null;
  var recommendationObservedSections = new WeakSet();
  var recommendationReadySections = new WeakSet();
  var hasProductContext = Boolean(settings.productId);
  var nativeCartEnabled = Boolean(document.body && document.body.dataset.dwNativeCartEnabled === 'true');

  function isClearanceContext(context) {
    var element = context && context.nodeType === 1 ? context : null;

    return Boolean(element && element.closest('[data-dw-clearance-product="true"]'));
  }

  function activePriceLabel(longLabel, context) {
    if (isClearanceContext(context)) {
      return longLabel ? (labels.clearancePrice || 'CLEARANCE') : (labels.clearance || 'CLEARANCE');
    }

    if (pricingMode === 'open_sale') {
      return longLabel ? (labels.salePrice || 'SALE PRICE') : (labels.sale || 'SALE');
    }

    return longLabel ? (labels.memberPrice || 'MEMBERS PRICE') : (labels.member || 'MEMBERS');
  }

  function text(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function createSpan(className, value) {
    var span = document.createElement('span');
    span.className = className;
    span.textContent = value;
    return span;
  }

  function priceNumber(value) {
    var match = text(value).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
  }

  function savingsText(rrp, memberPrice) {
    var rrpNumber = priceNumber(rrp);
    var memberNumber = priceNumber(memberPrice);

    if (!rrpNumber || !memberNumber || memberNumber >= rrpNumber) {
      return '';
    }

    var rrpCents = Math.round(rrpNumber * 100);
    var memberCents = Math.round(memberNumber * 100);
    if ((rrpCents - memberCents) * 100 < rrpCents * 2) return '';

    var discount = Math.round(((rrpNumber - memberNumber) * 100) / rrpNumber) + '%';
    var template = labels.discountOff || '[discount] OFF';

    return template.replace('[discount]', discount);
  }

  function getCurrentPrice(priceBlock) {
    var clone = priceBlock.cloneNode(true);
    var removable = clone.querySelectorAll(
      '.visually-hidden, .grid-product__price--original, .grid-product__price--savings, .grid-product__member-note, .grid-product__member-row'
    );

    removable.forEach(function(node) {
      node.remove();
    });

    return text(clone.textContent);
  }

  function getPriceBlocks(root) {
    var blocks = [];

    if (root && root.matches && root.matches('.grid-product__price')) {
      blocks.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('.grid-product__price').forEach(function(priceBlock) {
        blocks.push(priceBlock);
      });
    }

    return blocks;
  }

  function formatGridPrice(priceBlock) {
    if (priceBlock.getAttribute('data-dw-product-available') === 'false') return;
    if (priceBlock.hasAttribute(formattedAttribute)) {
      return;
    }

    var compare = priceBlock.querySelector('.grid-product__price--original');
    var clearance = isClearanceContext(priceBlock);

    if (clearance && !compare && !priceBlock.querySelector('.grid-product__member-row--member')) {
      var clearanceCurrent = priceBlock.querySelector('.grid-product__member-current');
      var clearancePrice = clearanceCurrent ? text(clearanceCurrent.textContent) : getCurrentPrice(priceBlock);

      if (clearancePrice) {
        var clearanceRow = createSpan('grid-product__member-row grid-product__member-row--member', '');
        clearanceRow.appendChild(createSpan('grid-product__member-label dw-price-label--clearance', activePriceLabel(false, priceBlock)));
        clearanceRow.appendChild(createSpan('grid-product__member-current', clearancePrice));
        priceBlock.textContent = '';
        priceBlock.classList.remove('grid-product__price--standard');
        priceBlock.classList.add('grid-product__price--member', 'grid-product__price--clearance');
        priceBlock.appendChild(clearanceRow);
        priceBlock.setAttribute(formattedAttribute, 'true');
        return;
      }
    }

    if (priceBlock.querySelector('.grid-product__member-row')) {
      if (priceBlock.querySelector('.grid-product__member-row--member')) {
        priceBlock.classList.add('grid-product__price--member');
      } else {
        priceBlock.classList.add('grid-product__price--standard');
      }
      priceBlock.setAttribute(formattedAttribute, 'true');
      return;
    }

    if (!compare) {
      var currentPrice = getCurrentPrice(priceBlock);

      if (!currentPrice) {
        return;
      }

      var regularRow = createSpan('grid-product__member-row grid-product__member-row--regular', '');

      regularRow.appendChild(createSpan('grid-product__member-current', currentPrice));

      priceBlock.textContent = '';
      priceBlock.classList.add('grid-product__price--standard');
      priceBlock.appendChild(regularRow);
      priceBlock.setAttribute(formattedAttribute, 'true');
      return;
    }

    var rrp = text(compare.textContent);
    var memberPrice = getCurrentPrice(priceBlock);

    if (!rrp || !memberPrice || rrp === memberPrice) {
      return;
    }

    if (!clearance && !savingsText(rrp, memberPrice)) {
      priceBlock.textContent = memberPrice;
      priceBlock.classList.remove('grid-product__price--member');
      priceBlock.classList.add('grid-product__price--standard');
      priceBlock.setAttribute(formattedAttribute, 'true');
      return;
    }

    var savings = priceBlock.querySelector('.grid-product__price--savings');
    var regularHidden = createSpan('visually-hidden', labels.regularPrice || 'Regular price');
    var saleHidden = createSpan(
      'visually-hidden',
      clearance ? activePriceLabel(true, priceBlock) : (labels.salePrice || 'Sale price')
    );
    var rrpRow = createSpan('grid-product__member-row grid-product__member-row--rrp', '');
    var memberRow = createSpan('grid-product__member-row grid-product__member-row--member', '');
    rrpRow.appendChild(createSpan('grid-product__price--original', rrp));

    memberRow.appendChild(createSpan('grid-product__member-label', activePriceLabel(false, priceBlock)));
    memberRow.appendChild(createSpan('grid-product__member-current', memberPrice));

    priceBlock.textContent = '';
    priceBlock.classList.add('grid-product__price--member');
    priceBlock.appendChild(regularHidden);
    priceBlock.appendChild(rrpRow);
    priceBlock.appendChild(saleHidden);
    priceBlock.appendChild(memberRow);

    if (savings) {
      priceBlock.appendChild(savings);
    }

    priceBlock.setAttribute(formattedAttribute, 'true');
  }

  function formatGridPrices(root) {
    getPriceBlocks(root || document).forEach(formatGridPrice);
  }

  function getCbbPriceContainers(root) {
    var blocks = [];

    if (root && root.matches && root.matches('.cbb-also-bought-product-price-container')) {
      blocks.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('.cbb-also-bought-product-price-container').forEach(function(priceBlock) {
        blocks.push(priceBlock);
      });
    }

    return blocks;
  }

  function formatCbbPrice(priceBlock) {
    if (priceBlock.hasAttribute(cbbFormattedAttribute)) {
      return;
    }

    var compare = priceBlock.querySelector('.cbb-also-bought-product-compare-at-price');
    var sale = priceBlock.querySelector('.cbb-also-bought-product-sale-price');
    var regular = priceBlock.querySelector('.cbb-also-bought-product-regular-price');
    var compareText = compare ? text(compare.textContent) : '';
    var saleText = sale ? text(sale.textContent) : '';
    var regularText = regular ? text(regular.textContent) : '';
    var currentNode = sale || regular;
    var currentText = saleText || regularText;

    var label = priceBlock.querySelector('.cbb-member-label');
    var saving = priceBlock.querySelector('.cbb-member-saving');
    var productCard = priceBlock.closest('.cbb-also-bought-product');

    if (productCard) {
      productCard.classList.toggle(
        'cbb-also-bought-product--has-variants',
        !!productCard.querySelector('.cbb-recommendations-variant-select')
      );
    }

    var clearance = isClearanceContext(priceBlock);
    var hasComparison = Boolean(compareText && saleText && compareText !== saleText);

    var qualifies = hasComparison && Boolean(savingsText(compareText, saleText));
    priceBlock.classList.toggle('dw-price-standard', !qualifies && !clearance);

    if (!qualifies && !clearance) {
      if (label) {
        label.remove();
      }
      if (saving) {
        saving.remove();
      }
      priceBlock.classList.remove('cbb-member-price');
      priceBlock.classList.add('cbb-standard-price');
      priceBlock.setAttribute(cbbFormattedAttribute, 'true');
      return;
    }

    var percent = hasComparison ? (priceNumber(compareText) - priceNumber(saleText)) * 100 / priceNumber(compareText) : 0;
    var quietPrice = settings.quietMemberPrices && isMembersMode && !clearance && percent > 0 && percent < 2;
    priceBlock.classList.toggle('dw-price-quiet', Boolean(quietPrice));
    var labelText = quietPrice ? (settings.loggedIn ? labels.quietMemberActive : labels.quietMember) : activePriceLabel(false, priceBlock);
    var savingTextValue = qualifies ? savingsText(compareText, saleText) : '';

    priceBlock.classList.remove('cbb-standard-price');
    priceBlock.classList.add('cbb-member-price');

    if (clearance && currentNode) {
      currentNode.classList.add('cbb-also-bought-product-sale-price');
    }

    if (!label) {
      label = createSpan('cbb-member-label', labelText);
      priceBlock.insertBefore(label, currentNode || null);
    } else if (label.textContent !== labelText) {
      label.textContent = labelText;
    }

    if (savingTextValue) {
      if (!saving) {
        saving = createSpan('cbb-member-saving', savingTextValue);
        priceBlock.appendChild(saving);
      } else if (saving.textContent !== savingTextValue) {
        saving.textContent = savingTextValue;
      }
    } else if (saving) {
      saving.remove();
    }

    priceBlock.setAttribute(cbbFormattedAttribute, 'true');
  }

  function formatCbbPrices(root) {
    var scope = root || document;
    var section = scope.matches && scope.matches('.cbb-also-bought-container')
      ? scope
      : scope.querySelector && scope.querySelector('.cbb-also-bought-container');
    var title = section && section.querySelector('.cbb-also-bought-title');

    if (section) {
      section.classList.add('cbb-also-bought-container--dw-native');
    }

    if (title && title.textContent !== 'Customers also bought') {
      title.textContent = 'Customers also bought';
    }

    getCbbPriceContainers(root || document).forEach(formatCbbPrice);
    scheduleCbbEnhancement(section);
  }

  function formatBoosterLabels(root) {
    var scope = root || document;
    var boosterLabels = [];

    if (scope.matches && scope.matches('.ba-product-member-label')) {
      boosterLabels.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('.ba-product-member-label').forEach(function(label) {
        boosterLabels.push(label);
      });
    }

    boosterLabels.forEach(function(label) {
      var row = label.closest('.ba-product-price-container');
      if (row) {
        var compare = row.querySelector('.ba-compare-at-price');
        var current = row.querySelector('.ba-regular-price');
        var qualifies = compare && current && Boolean(savingsText(compare.textContent, current.textContent));
        row.classList.toggle('dw-price-standard', !qualifies && !isClearanceContext(row));
      }
      setText(label, activePriceLabel(true, label));
    });
  }

  function storefrontRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function cardHandle(card) {
    var handleNode = card && card.querySelector('[data-f-href-handle], [data-dw-product-rating-handle]');
    var handle = handleNode && (
      handleNode.getAttribute('data-f-href-handle') ||
      handleNode.getAttribute('data-dw-product-rating-handle')
    );

    if (handle) {
      return handle;
    }

    var link = card && card.querySelector('a[href*="/products/"]');
    var match = link && link.getAttribute('href').match(/\/products\/([^?/#]+)/);

    return match ? match[1] : '';
  }

  function ensureCbbRatingTarget(card) {
    if (!card || card.querySelector('.dw-product-card-rating')) {
      return;
    }

    var handle = cardHandle(card);
    var name = card.querySelector('.cbb-also-bought-product-name');

    if (!handle || !name) {
      return;
    }

    var rating = document.createElement('div');
    rating.className = 'dw-product-card-rating grid-product__reviews--empty';
    rating.setAttribute('data-oke-reviews-product-listing-rating', '');
    rating.setAttribute('data-dw-product-rating-handle', handle);
    name.parentNode.insertBefore(rating, name.nextSibling);
  }

  function ratingTargets(root) {
    var scope = root || document;
    var targets = [];

    if (scope.matches && scope.matches('[data-dw-product-rating-handle]')) {
      targets.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('.cbb-also-bought-product').forEach(ensureCbbRatingTarget);
      scope.querySelectorAll('[data-dw-product-rating-handle]').forEach(function(target) {
        targets.push(target);
      });
    }

    return targets;
  }

  function applyRating(target, html) {
    target.innerHTML = html || '';
    target.classList.toggle('grid-product__reviews--empty', !text(target.textContent));
    target.classList.add('dw-product-card-rating--loaded');
  }

  function cachedRating(handle) {
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(ratingCachePrefix + handle));

      if (cached && Date.now() - cached.savedAt < ratingCacheLifetime) {
        return cached;
      }
    } catch (error) {
      // Ratings still load normally when storage is unavailable.
    }

    return null;
  }

  function cacheRating(handle, data) {
    try {
      window.sessionStorage.setItem(ratingCachePrefix + handle, JSON.stringify({
        html: data.html || '',
        title: data.title || '',
        clearance: Boolean(data.clearance),
        savedAt: Date.now()
      }));
    } catch (error) {
      // A full or disabled session store should not interrupt recommendations.
    }
  }

  function applyFullProductTitle(target, title) {
    var card = target && target.closest('.cbb-also-bought-product');
    var titleLink = card && card.querySelector('.cbb-also-bought-product-name a');

    if (!titleLink || !title || titleLink.textContent === title) {
      return;
    }

    titleLink.textContent = title;
    queueCbbTitleSync(card.closest('.cbb-also-bought-container'));
  }

  function applyClearanceState(target, isClearance) {
    var card;

    if (!target || !isClearance) return;

    card = target.closest(
      '.grid-product, .cbb-also-bought-product, .ba-product, ' +
      '.boost-sd__product-item, .boost-sd__suggestion-queries-item'
    );
    if (!card) return;

    card.setAttribute('data-dw-clearance-product', 'true');
    card.querySelectorAll(
      '.grid-product__member-label, .cbb-member-label, ' +
      '.ba-product-member-label, .upcart-member-label'
    ).forEach(function(label) {
      label.textContent = activePriceLabel(
        label.classList.contains('ba-product-member-label') || label.classList.contains('upcart-member-label'),
        card
      );
      label.classList.add('dw-price-label--clearance');
    });

    var gridPrice = card.querySelector('.grid-product__price');
    if (gridPrice && !gridPrice.querySelector('.grid-product__member-label')) {
      gridPrice.removeAttribute(formattedAttribute);
      formatGridPrice(gridPrice);
    }

    var cbbPrice = card.querySelector('.cbb-also-bought-product-price-container');
    if (cbbPrice && !cbbPrice.querySelector('.cbb-member-label')) {
      cbbPrice.removeAttribute(cbbFormattedAttribute);
      formatCbbPrice(cbbPrice);
    }
  }

  function loadRating(target) {
    var handle = target.getAttribute('data-dw-product-rating-handle');
    var cached;

    if (!handle) {
      applyRating(target, '');
      return Promise.resolve({ html: '', title: '' });
    }

    if (target.classList.contains('dw-product-card-rating--loaded')) {
      return Promise.resolve({ html: target.innerHTML, title: '' });
    }

    target.setAttribute('data-dw-rating-loading', 'true');

    if (!ratingRequests[handle]) {
      cached = cachedRating(handle);

      if (cached !== null) {
        ratingRequests[handle] = Promise.resolve(cached);
      } else {
        ratingRequests[handle] = fetch(
          storefrontRoot() + 'products/' + encodeURIComponent(handle) + '?view=dw-card-data',
          { credentials: 'same-origin' }
        ).then(function(response) {
          if (!response.ok) throw new Error('Product card data unavailable');
          return response.text();
        }).then(function(markup) {
          if (!markup) {
            return { html: '', title: '', clearance: false };
          }

          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var cardData = parsed.querySelector('[data-dw-product-card-data]');
          var snippet = parsed.querySelector('[data-dw-review-snippet]');
          var data = {
            html: snippet ? snippet.innerHTML : '',
            title: cardData ? cardData.getAttribute('data-product-title') || '' : '',
            clearance: cardData ? cardData.getAttribute('data-product-clearance') === 'true' : false
          };

          cacheRating(handle, data);
          return data;
        }).catch(function() {
          delete ratingRequests[handle];
          return null;
        });
      }
    }

    return ratingRequests[handle].then(function(data) {
      if (!data) {
        target.removeAttribute('data-dw-rating-loading');
        target.removeAttribute(ratingObservedAttribute);
        return '';
      }

      applyRating(target, data.html || '');
      applyFullProductTitle(target, data.title || '');
      applyClearanceState(target, Boolean(data.clearance));
      target.removeAttribute('data-dw-rating-loading');
      return data.html || '';
    });
  }

  function preloadRecommendationRatings(section) {
    if (!section) {
      return;
    }

    ratingTargets(section).forEach(loadRating);
  }

  function observeProductRatings(root) {
    if (!ratingObserver && 'IntersectionObserver' in window) {
      ratingObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            return;
          }

          ratingObserver.unobserve(entry.target);
          loadRating(entry.target);
        });
      }, { rootMargin: '1100px 0px' });
    }

    ratingTargets(root || document).forEach(function(target) {
      if (target.hasAttribute(ratingObservedAttribute)) {
        return;
      }

      target.setAttribute(ratingObservedAttribute, 'true');

      if (ratingObserver) {
        ratingObserver.observe(target);
      } else {
        loadRating(target);
      }
    });
  }

  function recommendationImage(product) {
    var image = product.featured_image || (product.images && product.images[0]);

    if (typeof image === 'string') {
      return image;
    }

    return image && (image.url || image.src) || '';
  }

  function buildFallbackRecommendation(product) {
    var card = document.createElement('li');
    var imageLink = document.createElement('a');
    var image = document.createElement('div');
    var name = document.createElement('h3');
    var nameLink = document.createElement('a');
    var price = document.createElement('div');
    var productUrl = product.url || (storefrontRoot() + 'products/' + product.handle);
    var imageUrl = recommendationImage(product);
    var currentPrice = product.price_min || product.price || 0;
    var comparePrice = product.compare_at_price_min || product.compare_at_price || 0;

    card.className = 'cbb-also-bought-product dw-recommendation-fallback';
    card.setAttribute('data-dw-recommendation-handle', product.handle || '');

    imageLink.className = 'cbb-also-bought-product-image-link';
    imageLink.href = productUrl;
    imageLink.setAttribute('data-f-href-handle', product.handle || '');
    imageLink.setAttribute('aria-label', product.title || 'Recommended product');

    image.className = 'cbb-also-bought-product-image';
    image.setAttribute('role', 'img');
    image.setAttribute('aria-label', product.title || 'Recommended product');
    if (imageUrl) {
      image.style.backgroundImage = 'url("' + imageUrl.replace(/"/g, '%22') + '")';
    }
    imageLink.appendChild(image);

    name.className = 'cbb-also-bought-product-name';
    nameLink.href = productUrl;
    nameLink.setAttribute('data-f-href-handle', product.handle || '');
    nameLink.textContent = product.title || '';
    name.appendChild(nameLink);

    price.className = 'cbb-also-bought-product-price-container';
    if (comparePrice > currentPrice) {
      price.appendChild(createSpan('cbb-also-bought-product-compare-at-price', money(comparePrice)));
      price.appendChild(createSpan('cbb-also-bought-product-sale-price', money(currentPrice)));
    } else {
      price.appendChild(createSpan('cbb-also-bought-product-regular-price', money(currentPrice)));
    }

    card.appendChild(imageLink);
    card.appendChild(name);
    card.appendChild(price);

    return card;
  }

  function updateRecommendationNavigation(section) {
    var slider = section.querySelector('.cbb-also-bought-slider');
    var cards = section.querySelectorAll('.cbb-also-bought-product');
    var nav = section.querySelector('.dw-recommendations-nav');

    if (!slider || cards.length <= 5) {
      if (nav) {
        nav.hidden = true;
      }
      return;
    }

    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'dw-recommendations-nav';
      nav.innerHTML = [
        '<button type="button" class="dw-recommendations-nav__button dw-recommendations-nav__button--prev" aria-label="Previous recommendations">&#8249;</button>',
        '<button type="button" class="dw-recommendations-nav__button dw-recommendations-nav__button--next" aria-label="More recommendations">&#8250;</button>'
      ].join('');
      section.appendChild(nav);

      nav.querySelector('.dw-recommendations-nav__button--prev').addEventListener('click', function() {
        recommendationReadySections.add(section);
        addRecommendationFallbacks(section);
        preloadRecommendationRatings(section);
        slider.scrollBy({ left: -slider.clientWidth * 0.82, behavior: 'smooth' });
      });
      nav.querySelector('.dw-recommendations-nav__button--next').addEventListener('click', function() {
        recommendationReadySections.add(section);
        addRecommendationFallbacks(section);
        preloadRecommendationRatings(section);
        slider.scrollBy({ left: slider.clientWidth * 0.82, behavior: 'smooth' });
      });
    }

    nav.hidden = false;

    var updateButtons = function() {
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      nav.querySelector('.dw-recommendations-nav__button--prev').disabled = slider.scrollLeft <= 4;
      nav.querySelector('.dw-recommendations-nav__button--next').disabled = slider.scrollLeft >= maxScroll - 4;
    };

    if (!slider.hasAttribute('data-dw-recommendation-nav-bound')) {
      slider.setAttribute('data-dw-recommendation-nav-bound', 'true');
      slider.addEventListener('scroll', updateButtons, { passive: true });
    }

    window.requestAnimationFrame(updateButtons);
  }

  function syncCbbTitleHeights(section) {
    if (!section) {
      return;
    }

    var titles = Array.prototype.slice.call(
      section.querySelectorAll('.cbb-also-bought-product-name')
    );

    if (!titles.length) {
      return;
    }

    titles.forEach(function(title) {
      title.style.setProperty('height', 'auto', 'important');
    });

    window.requestAnimationFrame(function() {
      var tallest = titles.reduce(function(height, title) {
        return Math.max(height, Math.ceil(title.scrollHeight));
      }, 0);

      if (!tallest) {
        return;
      }

      titles.forEach(function(title) {
        title.style.setProperty('height', tallest + 'px', 'important');
      });
    });
  }

  function queueCbbTitleSync(section) {
    window.clearTimeout(cbbTitleSyncTimer);
    cbbTitleSyncTimer = window.setTimeout(function() {
      syncCbbTitleHeights(section);
    }, 50);
  }

  function addRecommendationFallbacks(section) {
    var list = section.querySelector('.cbb-also-bought-slider-list');
    var existingCards = section.querySelectorAll('.cbb-also-bought-product');

    updateRecommendationNavigation(section);
    queueCbbTitleSync(section);
    observeProductRatings(section);

    if (!list || existingCards.length >= recommendationTargetCount ||
        section.hasAttribute(recommendationFallbackAttribute) || !settings.productId) {
      return;
    }

    section.setAttribute(recommendationFallbackAttribute, 'true');

    var handles = {};
    existingCards.forEach(function(card) {
      var handle = cardHandle(card);
      if (handle) {
        handles[handle] = true;
      }
    });
    if (settings.productHandle) {
      handles[settings.productHandle] = true;
    }

    fetch(
      storefrontRoot() + 'recommendations/products.json?product_id=' +
        encodeURIComponent(settings.productId) + '&limit=10&intent=related',
      { credentials: 'same-origin' }
    ).then(function(response) {
      if (!response.ok) throw new Error('Recommendations unavailable');
      return response.json();
    }).then(function(payload) {
      var count = list.querySelectorAll('.cbb-also-bought-product').length;

      (payload.products || []).some(function(product) {
        if (count >= recommendationTargetCount) {
          return true;
        }
        if (!product.handle || handles[product.handle]) {
          return false;
        }

        handles[product.handle] = true;
        list.appendChild(buildFallbackRecommendation(product));
        count++;
        return false;
      });

      formatCbbPrices(section);
      observeProductRatings(section);
      updateRecommendationNavigation(section);
      queueCbbTitleSync(section);
    }).catch(function() {
      section.removeAttribute(recommendationFallbackAttribute);
      updateRecommendationNavigation(section);
      queueCbbTitleSync(section);
    });
  }

  function scheduleCbbEnhancement(section) {
    if (!section) {
      return;
    }

    if ('IntersectionObserver' in window && !recommendationReadySections.has(section)) {
      if (!recommendationObserver) {
        recommendationObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;

            recommendationObserver.unobserve(entry.target);
            recommendationReadySections.add(entry.target);
            scheduleCbbEnhancement(entry.target);
          });
        }, { rootMargin: '1100px 0px' });
      }

      if (!recommendationObservedSections.has(section)) {
        recommendationObservedSections.add(section);
        recommendationObserver.observe(section);
      }
      return;
    }

    window.clearTimeout(cbbEnhanceTimer);
    cbbEnhanceTimer = window.setTimeout(function() {
      addRecommendationFallbacks(section);
      queueCbbTitleSync(section);
    }, 450);
  }

  function loginUnlockHtml() {
    return settings.loginUnlockHtml || '<a href="/account/login">Sign up or login for free</a> to access exclusive members deals';
  }

  function memberPromptHtml() {
    var title = labels.cartBannerTitle || 'Dwights Members';
    var action = labels.cartBannerAction || 'Unlock members deals';
    var loginUrl = settings.loginUrl || '/account/login';

    return [
      '<div class="upcart-member-login-note__content">',
        '<div class="upcart-member-login-note__title">', title, '</div>',
        '<div class="upcart-member-login-note__copy">', loginUnlockHtml(), '</div>',
      '</div>',
      '<a class="upcart-member-login-note__action" href="', loginUrl, '">', action, '</a>'
    ].join('');
  }

  function removeNode(node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  }

  function setText(node, value) {
    if (node && node.textContent !== value) {
      node.textContent = value;
    }
  }

  function directChildOf(parent, node) {
    var current = node;

    while (current && current.parentNode !== parent) {
      current = current.parentNode;
    }

    return current || node;
  }

  function getUpcartProductPriceBlocks(root) {
    var blocks = [];

    if (root && root.matches && root.matches('.styles_ProductRow__price__') && root.closest('#UpcartPopup')) {
      blocks.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('.styles_ProductRow__price__').forEach(function(priceBlock) {
        if (!priceBlock.closest('#UpcartPopup')) {
          return;
        }

        blocks.push(priceBlock);
      });
    }

    return blocks;
  }

  function getUpcartUpsellPriceRows(root) {
    var rows = [];

    if (root && root.matches && root.matches('.upcart-upsell-item-price-row') && root.closest('#UpcartPopup')) {
      rows.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('.upcart-upsell-item-price-row').forEach(function(row) {
        if (!row.closest('#UpcartPopup')) {
          return;
        }

        rows.push(row);
      });
    }

    return rows;
  }

  function formatUpcartSaleRow(row, compareSelector, saleSelector) {
    var compare = row.querySelector(compareSelector);
    var sale = row.querySelector(saleSelector);
    var compareText = compare ? text(compare.textContent) : '';
    var saleText = sale ? text(sale.textContent) : '';
    var label = row.querySelector('.' + upcartMemberLabelClass);
    var saving = row.querySelector('.' + upcartMemberSavingClass);
    var savingTextValue = savingsText(compareText, saleText);

    if (!compareText || !saleText || !savingTextValue) {
      removeNode(label);
      removeNode(saving);
      row.classList.remove('upcart-member-price');
      row.classList.add('upcart-price-standard');
      return '';
    }

    row.classList.remove('upcart-price-standard');
    row.classList.add('upcart-member-price');

    if (!label) {
      label = createSpan(upcartMemberLabelClass, activePriceLabel(true, row));
      row.insertBefore(label, directChildOf(row, sale));
    } else {
      setText(label, activePriceLabel(true, row));
    }

    if (saving) {
      setText(saving, savingTextValue);
    }

    return savingTextValue;
  }

  function formatUpcartProductPrice(priceBlock) {
    var row = priceBlock.querySelector('.upcart-item-prices-row');

    if (!row) {
      return;
    }

    if (isMembersMode && !settings.loggedIn) {
      var compare = row.querySelector('.upcart-item-compare-price');
      var sale = row.querySelector('.upcart-item-price');
      var compareText = compare ? text(compare.textContent) : '';
      var saleText = sale ? text(sale.textContent) : '';
      var isMemberPair = row.getAttribute('data-guest-full-price') === 'true' ||
        !!savingsText(compareText, saleText);

      if (isMemberPair && compareText && sale) {
        row.setAttribute('data-guest-full-price', 'true');
        setText(sale, compareText);
        compare.hidden = true;
        removeNode(row.querySelector('.' + upcartMemberLabelClass));
        removeNode(row.querySelector('.' + upcartMemberSavingClass));
        removeNode(priceBlock.querySelector('.upcart-product-savings'));
        row.classList.remove('upcart-member-price');
        row.classList.add('upcart-price-standard');
        priceBlock.classList.remove('upcart-member-price');
        priceBlock.classList.add('upcart-price-standard');
        return;
      }
    }

    var savingTextValue = formatUpcartSaleRow(row, '.upcart-item-compare-price', '.upcart-item-price');
    var saving = priceBlock.querySelector('.upcart-product-savings');

    if (!savingTextValue) {
      removeNode(saving && saving.classList.contains(upcartMemberSavingClass) ? saving : null);
      priceBlock.classList.remove('upcart-member-price');
      priceBlock.classList.add('upcart-price-standard');
      return;
    }

    priceBlock.classList.remove('upcart-price-standard');
    priceBlock.classList.add('upcart-member-price');

    if (!saving) {
      saving = createSpan('upcart-product-savings ' + upcartMemberSavingClass, savingTextValue);
      priceBlock.appendChild(saving);
    } else {
      saving.classList.add(upcartMemberSavingClass);
      setText(saving, savingTextValue);
    }
  }

  function formatUpcartUpsellPrice(row) {
    var savingTextValue = formatUpcartSaleRow(row, '.upcart-upsell-item-compare-price', '.upcart-upsell-item-price');
    var saving = row.querySelector('.' + upcartMemberSavingClass);

    if (!savingTextValue) {
      removeNode(saving);
      return;
    }

    if (!saving) {
      row.appendChild(createSpan(upcartMemberSavingClass, savingTextValue));
    } else {
      setText(saving, savingTextValue);
    }
  }

  function formatUpcartLoginNote(root) {
    var popup = (root && root.matches && root.matches('#UpcartPopup')) ? root : document.querySelector('#UpcartPopup');
    var footer = popup ? popup.querySelector('.upcart-footer') : null;
    var cartBody = popup ? popup.querySelector('.upcart-cart-body') : null;
    var cartCard = cartBody ? cartBody.parentElement : null;
    var note = popup ? popup.querySelector('.upcart-member-login-note') : null;
    var hasItems = popup && !!popup.querySelector('.upcart-product-item');

    if ((!footer && !cartCard) || !isMembersMode || settings.loggedIn || !hasItems) {
      removeNode(note);
      return;
    }

    if (!note) {
      note = document.createElement('div');
      note.className = 'upcart-member-login-note';
      note.setAttribute('data-member-pricing-note', 'true');
      note.innerHTML = memberPromptHtml();
      (cartCard || footer).insertBefore(note, cartBody || footer.firstElementChild);
    } else if (!note.hasAttribute('data-member-pricing-note')) {
      note.setAttribute('data-member-pricing-note', 'true');
      note.innerHTML = memberPromptHtml();
    }

    if (cartCard && cartBody && note.parentElement !== cartCard) {
      cartCard.insertBefore(note, cartBody);
    }
  }

  function hasUpcartContext(root) {
    if (nativeCartEnabled) {
      return false;
    }

    if (!root || root === document || root.nodeType === 9) {
      return true;
    }

    if (!root.matches || !root.querySelector) {
      return false;
    }

    return root.matches('#UpcartPopup, #UpcartPopup *') || !!root.querySelector('#UpcartPopup, .upcart-product-item, .upcart-upsell-item-price-row, .upcart-footer');
  }

  function formatUpcart(root) {
    if (!hasUpcartContext(root)) {
      return;
    }

    getUpcartProductPriceBlocks(root || document).forEach(formatUpcartProductPrice);
    getUpcartUpsellPriceRows(root || document).forEach(formatUpcartUpsellPrice);
    formatUpcartLoginNote(root || document);
  }

  function queueMemberPricingScope(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var covered = memberPricingSyncScopes.some(function(pendingScope) {
      return pendingScope === scope ||
        (pendingScope.contains && pendingScope.contains(scope));
    });

    if (covered) return;

    memberPricingSyncScopes = memberPricingSyncScopes.filter(function(pendingScope) {
      return !(scope.contains && scope.contains(pendingScope));
    });
    memberPricingSyncScopes.push(scope);
  }

  function scheduleMemberPricingSync(root) {
    queueMemberPricingScope(root);
    if (memberPricingSyncQueued) return;

    memberPricingSyncQueued = true;
    window.requestAnimationFrame(function() {
      var scopes = memberPricingSyncScopes.slice();

      memberPricingSyncScopes = [];
      memberPricingSyncQueued = false;
      scopes.forEach(function(scope) {
        formatGridPrices(scope);
        if (hasProductContext) {
          formatCbbPrices(scope);
          observeProductRatings(scope);
        }
        formatBoosterLabels(scope);
        formatUpcart(scope);
      });
      document.documentElement.setAttribute('data-dw-member-pricing-lifecycle', 'ready');
    });
  }

  function isMemberPricingNode(node) {
    if (!node || node.nodeType !== 1) return false;

    var selector = '.grid-product__price, .ba-product-member-label';
    var descendantSelector = '.grid-product__price, .ba-product-member-label';

    if (!nativeCartEnabled) {
      selector += ', #UpcartPopup, #UpcartPopup *';
      descendantSelector += ', #UpcartPopup';
    }

    if (hasProductContext) {
      selector += ', .cbb-also-bought-container, .cbb-also-bought-product-price-container, [data-dw-product-rating-handle]';
      descendantSelector += ', .cbb-also-bought-container, .cbb-also-bought-product-price-container, [data-dw-product-rating-handle]';
    }

    return node.matches(selector) || Boolean(node.querySelector(descendantSelector));
  }

  function init() {
    formatGridPrices(document);
    if (hasProductContext) {
      formatCbbPrices(document);
      observeProductRatings(document);
    }
    formatBoosterLabels(document);
    formatUpcart(document);
    document.documentElement.setAttribute('data-dw-member-pricing-lifecycle', 'ready');

    if (hasProductContext) {
      window.addEventListener('resize', function() {
        var section = document.querySelector('.cbb-also-bought-container');
        queueCbbTitleSync(section);
      });
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        var gridPrice = target && target.closest('.grid-product__price');
        var cbbPrice = hasProductContext && target && target.closest('.cbb-also-bought-product-price-container');
        var cbbSection = hasProductContext && target && target.closest('.cbb-also-bought-container');
        var upcart = !nativeCartEnabled && target && target.closest('#UpcartPopup');

        if (upcart) {
          scheduleMemberPricingSync(upcart);
          return;
        }

        if (gridPrice) {
          gridPrice.removeAttribute(formattedAttribute);
          scheduleMemberPricingSync(gridPrice);
          return;
        }

        if (hasProductContext && cbbPrice) {
          cbbPrice.removeAttribute(cbbFormattedAttribute);
          scheduleMemberPricingSync(cbbSection || cbbPrice);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes || [], function(node) {
          if (isMemberPricingNode(node)) scheduleMemberPricingSync(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
